/**
 * Textos (`es`) del tall «selfchecks» de Qualitat i APPCC. Tall propi: no es toca `es.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const selfChecksEs = {
  'backoffice.selfChecks': {
    subtitle:
      'Los controles que hace el equipo cada día, semana o mes (limpieza, temperaturas, plagas…): qué hay que comprobar y qué se ha registrado.',
    tabsLabel: 'Secciones de los autocontroles',
    tabRecords: 'Registros',
    tabMissed: 'Registros no hechos',
    tabTemplates: 'Plantillas',
    loadError: 'No se han podido cargar los datos. Vuelve a intentarlo.',
    loading: 'Cargando…',

    // Enums
    kind_cleaning: 'Limpieza y desinfección',
    kind_temperature: 'Temperaturas',
    kind_pests: 'Control de plagas',
    kind_custom: 'Otros',
    frequency_daily: 'Diaria',
    frequency_weekly: 'Semanal',
    frequency_monthly: 'Mensual',
    fieldType_ok_ko: 'OK / KO',
    fieldType_number: 'Número',
    fieldType_text: 'Texto',
    fieldType_photo: 'Foto',
    result_ok: 'OK',
    result_ko: 'KO',

    // Períodos
    periodWeek: 'Semana {{week}} · {{from}} – {{to}}',

    // Registros
    filterTemplate: 'Plantilla',
    filterTemplateAll: 'Todas las plantillas',
    filterResult: 'Resultado',
    filterResultAll: 'Todos',
    filterFrom: 'Desde el día',
    filterTo: 'Hasta el día',
    recordsEmpty: 'Todavía no hay ningún registro de autocontrol.',
    recordsEmptyFiltered: 'Ningún registro coincide con los filtros.',
    recordsTruncated:
      'Se muestran los {{limit}} registros más recientes. Afina los filtros para ver otros.',
    recordPeriod: 'Período',
    recordDoneBy: 'Hecho por {{name}} · {{when}}',
    unknownPerson: 'Persona desconocida',
    templateInactive: '{{name}} (baja)',
    templateUnknown: '(plantilla no disponible)',
    notesLabel: 'Observaciones',
    fieldUnavailable: '(campo retirado)',
    valueOutOfRange: 'Fuera de rango',
    valueNoAnswer: 'Sin respuesta',
    valueRange: 'rango {{min}} – {{max}}',
    valueRangeMin: 'mínimo {{min}}',
    valueRangeMax: 'máximo {{max}}',
    photoView: 'Ver la foto',
    photoOpening: 'Abriendo…',
    photoError: 'No se ha podido abrir la foto.',
    ncLabel: 'No conformidad',
    ncLinksError: 'No se han podido cargar los enlaces a las no conformidades.',

    // Registros no hechos
    missedIntro:
      'Períodos en los que tocaba hacer un autocontrol y no hay ningún registro. Cada plantilla cuenta desde el día en que se creó y hasta que se dio de baja. El período en curso no sale hasta que termina.',
    missedRangeHint: 'Como mucho un año; el último día es ayer.',
    missedEmpty: 'No hay ningún período sin hacer en este intervalo. Todo al día.',
    missedEmptyNoTemplates:
      'Todavía no hay ninguna plantilla. Crea las de base en la pestaña Plantillas.',
    missedCount_one: '{{count}} período sin hacer',
    missedCount_other: '{{count}} períodos sin hacer',
    missedColTemplate: 'Plantilla',
    missedColFrequency: 'Frecuencia',
    missedColPeriod: 'Período',
    missedColDue: 'Vencimiento',
    dueTitle: 'Toca ahora',
    dueHint: 'Plantillas que todavía no tienen ningún registro en su período en curso.',
    dueEmpty: 'Todos los autocontroles de ahora están hechos.',
    duePending: 'Pendiente',

    // Plantillas
    templatesTitle: 'Plantillas de autocontrol',
    templatesSubtitle:
      'Qué hay que comprobar, cada cuánto y dónde. Una plantilla dada de baja deja de tocar, pero los registros que ya tiene se conservan.',
    colName: 'Nombre',
    colKind: 'Tipo',
    colFrequency: 'Frecuencia',
    colZone: 'Zona',
    colEquipment: 'Equipo',
    colFields: 'Campos',
    newTemplate: 'Nueva plantilla',
    editTemplate: 'Edita la plantilla',
    searchLabel: 'Busca por nombre, tipo o zona',
    filterKindAll: 'Todos los tipos',
    filterFrequencyAll: 'Todas las frecuencias',
    emptyTemplates:
      'Todavía no hay ninguna plantilla. Puedes crear las tres de base (limpieza y desinfección, temperaturas y plagas) y adaptarlas.',
    seedAction: 'Crea las plantillas de base',
    seeding: 'Creando…',
    seedCreated_one: 'Se ha creado {{count}} plantilla de base.',
    seedCreated_other: 'Se han creado {{count}} plantillas de base.',
    seedNone: 'Las plantillas de base ya estaban: no se ha creado nada.',
    seedError: 'No se han podido crear las plantillas de base.',
    deactivateTitle: 'Da de baja la plantilla',
    deactivateBody:
      'La plantilla dejará de tocar en la App y de contar en los registros no hechos. Los registros que ya tiene se conservan. Hace falta un motivo.',
    actionError: 'No se ha podido completar la acción. Vuelve a intentarlo.',

    // Diálogo de plantilla
    sectionTemplate: 'Plantilla',
    sectionFields: 'Campos a comprobar',
    sectionFieldsHint:
      'Cada campo es algo que el operario tiene que contestar. Un KO o un número fuera de rango abre una no conformidad.',
    fieldName: 'Nombre',
    fieldKind: 'Tipo de autocontrol',
    fieldFrequency: 'Frecuencia',
    fieldFrequencyHint: 'Cada período (un día, una semana o un mes) se puede hacer una sola vez.',
    fieldFrequencyLocked:
      'Esta plantilla ya tiene registros: la frecuencia no se puede cambiar. Dala de baja y crea una nueva.',
    fieldZone: 'Zona',
    fieldZoneNone: 'Sin zona',
    fieldEquipment: 'Equipo',
    fieldEquipmentNone: 'Sin equipo',
    optionUnavailable: '(no disponible)',
    fieldSortOrder: 'Orden',
    fieldSortOrderHint: 'Las plantillas se muestran en este orden.',
    fieldInstructions: 'Instrucciones',
    fieldInstructionsHint: 'El operario las ve antes de hacer el autocontrol.',
    fieldsEmpty: 'Todavía no hay ningún campo. Añade uno para empezar.',
    addField: 'Añade un campo',
    fieldLabel: 'Qué se comprueba',
    fieldTypeLabel: 'Tipo de respuesta',
    fieldTypeLocked: 'El tipo no se puede cambiar una vez creado el campo.',
    fieldRequired: 'Obligatorio',
    fieldMin: 'Mínimo',
    fieldMax: 'Máximo',
    fieldUnit: 'Unidad',
    fieldRangeHint: 'Fuera de este rango el valor es KO.',
    fieldPosition: 'Campo {{n}}',
    moveUp: 'Sube',
    moveDown: 'Baja',
    removeField: 'Quita',
    errorName: 'Escribe el nombre de la plantilla.',
    errorFieldLabel: 'Cada campo necesita un nombre.',
    errorRange: 'El mínimo no puede ser mayor que el máximo.',
    errorDuplicateName: 'Ya hay una plantilla vigente con este nombre.',
    saveError: 'No se ha podido guardar la plantilla. Vuelve a intentarlo.',
  },
} as const;
